const firebaseConfig = {
    apiKey: "AIzaSyCW9p2T3mYsINykbPyPrY-Eh16D6bR5O8A",
    authDomain: "vehicle-rides.firebaseapp.com",
    projectId: "vehicle-rides",
    storageBucket: "vehicle-rides.appspot.com",
    messagingSenderId: "217079051280",
    appId: "1:217079051280:web:8a74da3d93c49f926f0695"
};
export default firebaseConfig;